"use client";

import type { FC } from "react";
import { Box } from "@ecco/ui/box";
import { VStack } from "@ecco/ui/stack";
import { Text } from "@ecco/ui/text";
import { Button } from "@ecco/ui/button";
import { RichText } from "@components/cms/rich-text-renderer/RichText";
import { useGlobalModalContext } from "@components/GlobalModalProvider/GlobalModalProvider";
import { useGlobalContent } from "@app/[locale]/GlobalContentProvider";
import { ModalTypes } from "@lib/enums/ModalTypes";
import { useIsLoyaltyMember } from "@hooks/useIsLoyaltyMember";
import { styles } from "./AccountDeactivationSection.styles";
import { ACCOUNT_DEACTIVATION_SECTION_TEST_IDS } from "./constants";
import { useAccountDeactivationSectionHeaders } from "./useAccountDeactivationSectionHeaders";

export const AccountDeactivationSection: FC = () => {
    const { showModal } = useGlobalModalContext();
    const { isLoyaltyMember } = useIsLoyaltyMember();
    const { title, deactivateLink } = useAccountDeactivationSectionHeaders();
    const { siteSettings } = useGlobalContent();

    const pageDescription = siteSettings.account.deactivationPageDescription;

    const handleDeactivateClick = () => {
        showModal(ModalTypes.accountDeactivation, { isLoyaltyMember });
    };

    return (
        <Box sx={styles.section} data-testid={ACCOUNT_DEACTIVATION_SECTION_TEST_IDS.section}>
            <VStack alignItems="flex-start" spacing={0}>
                <Text sx={styles.title} data-testid={ACCOUNT_DEACTIVATION_SECTION_TEST_IDS.title}>
                    {title}
                </Text>
                {pageDescription && (
                    <Box mt={4} data-testid={ACCOUNT_DEACTIVATION_SECTION_TEST_IDS.description}>
                        <RichText data={pageDescription} />
                    </Box>
                )}
                <Button
                    variant="link"
                    colorScheme="gray"
                    textTransform="capitalize"
                    mt={10}
                    onClick={handleDeactivateClick}
                    data-testid={ACCOUNT_DEACTIVATION_SECTION_TEST_IDS.deactivateLink}
                >
                    {deactivateLink}
                </Button>
            </VStack>
        </Box>
    );
};

export default AccountDeactivationSection;
